import semesterReducer from './reducers';

import * as semesterOperations from './operations';
import * as semesterActions from './actions';
import * as semesterSelectors from './selectors';

export { semesterOperations, semesterActions, semesterSelectors };

export default semesterReducer;
